import React from 'react';

import Immutable from 'immutable';

import {
  Paragraph,
} from '@uncinc/react-drupal-core';

import useClasses from '../../../hooks/useClasses';

import './style.scss';

const ParagraphFrontPagePrograms = ({ entity, className }) => {
  const { buildClass, joinClasses } = useClasses('ParagraphFrontPagePrograms');

  const paragraphs = entity.get('field_paragraphs', Immutable.List());

  return (
    <article className={joinClasses(buildClass(), className)}>
      {paragraphs.size > 0 && (
        <div className={buildClass('paragraphs')}>
          {paragraphs.map((paragraph) => {
            const id = paragraph.get('target_id');
            const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);
            return (
              <Paragraph
                key={`paragraph:${id}:${language}`}
                id={id}
                entity={paragraph.get('entity')}
              />
            );
          })}
        </div>
      )}
    </article>
  );
};

export default ParagraphFrontPagePrograms;
